import * as yup from 'yup';

import { TrlFormattedMessagePlain } from '»utils/i18n';

yup.addMethod(
  yup.number,
  'verifyDecimalPlaces',
  function verifyDecimalPlaces(
    maxDecimalPlacesMessage,
    isFunds,
    quantityPrecision,
  ) {
    return this.test({
      name: 'verifyDecimalPlaces',
      test: (value, context) => {
        const { createError } = context;

        if (isFunds) {
          const decimalPart = value.toString().split('.')[1];

          if (decimalPart && decimalPart.length > quantityPrecision)
            return createError({ message: maxDecimalPlacesMessage });
        }

        return true;
      },
    });
  },
);

export const trlInsertOrderPrimaryValidation = ({
  dataItem,
  activeStep,
  useOtp,
  isFundsListPage,
}) => {
  const {
    minAmount,
    maxAmount,
    minQuantity,
    maxQuantity,
    trancheType,
    price,
    minPrice,
    offerMinPrice,
    maxPrice,
    offerMaxPrice,
    minimumBatch,
    subscriptionPrice,
    initialAmount,
    quantityPrecision,
  } = dataItem;

  const fieldMustBeNumber = TrlFormattedMessagePlain({
    id: 'TRLT_UI-NUMBER_FIELD',
  });

  const factor = 10 ** quantityPrecision;
  const minFundsQty =
    Math.ceil((initialAmount / Number(subscriptionPrice)) * factor) / factor;

  return yup.object().shape({
    inputQuantity: yup
      .number('NUMBER')
      .typeError(fieldMustBeNumber)
      .required(TrlFormattedMessagePlain({ id: 'TRLT_UI-REQUIRED_FIELD' }))
      .verifyDecimalPlaces(
        TrlFormattedMessagePlain({
          id: 'TRLT_UI-DECIMAL_PLACES_LOWER_THAN',
          values: { min: quantityPrecision },
        }),
        isFundsListPage,
        quantityPrecision,
      )
      .test(
        'min-test',
        TrlFormattedMessagePlain({
          id: `${
            trancheType === 'R'
              ? 'TRLT_UI-AMOUNT_BIGGER'
              : 'TRLT_UI-QUANTITY_BIGGER'
          }`,
          values: {
            min: isFundsListPage
              ? minFundsQty
              : trancheType === 'R'
                ? minAmount
                : minQuantity,
          },
        }),
        (value) => {
          if (isFundsListPage) return value >= minFundsQty;

          if (trancheType === 'R') return value >= minAmount;

          return value >= minQuantity;
        },
      )
      .test(
        'max-test',
        TrlFormattedMessagePlain({
          id: `${
            trancheType === 'R'
              ? 'TRLT_UI-AMOUNT_SMALLER'
              : 'TRLT_UI-QUANTITY_SMALLER'
          }`,
          values:
            trancheType === 'R' ? { max: maxAmount } : { max: maxQuantity },
        }),
        (value) => {
          if (isFundsListPage) return true;

          if (trancheType === 'R') return value <= maxAmount;

          return value <= maxQuantity;
        },
      )
      .test(
        'is-multiple',
        TrlFormattedMessagePlain({ id: 'TRLT_UI-NOT_MULTIPLE' }),
        (value) => {
          if (trancheType === 'R' || isFundsListPage) return true;

          return (value - minQuantity) % minimumBatch === 0;
        },
      ),
    inputPrice: yup
      .number('NUMBER')
      .typeError(fieldMustBeNumber)
      .nullable()
      .positive()
      .min(
        trancheType !== 'R' ? (!price ? (minPrice ?? offerMinPrice) : 0.1) : 0,
        TrlFormattedMessagePlain({
          id: `${'TRLT_UI-PRICE_BIGGER'}`,
          values: { min: !price ? (minPrice ?? offerMinPrice) : null },
        }),
      )
      .max(
        trancheType !== 'R'
          ? !price
            ? (maxPrice ?? offerMaxPrice)
            : Number.POSITIVE_INFINITY
          : Number.POSITIVE_INFINITY,
        TrlFormattedMessagePlain({
          id: `${'TRLT_UI-PRICE_SMALLER'}`,
          values: { max: !price ? (maxPrice ?? offerMaxPrice) : null },
        }),
      ),
    validationCode: yup
      .string()
      .test(
        'isRequired',
        TrlFormattedMessagePlain({ id: 'TRLT_UI-REQUIRED_FIELD' }),
        function isRequired(value) {
          if (useOtp && activeStep === 1 && !value) return false;

          return true;
        },
      ),
  });
};
